'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';
import '../../libs/geoxml3.js';
import 'ngmap';
import MarkerClusterer from 'marker-clusterer-plus';
window.MarkerClusterer = MarkerClusterer;

EwSiteApp.requires.push('ngMap');

EwSiteApp.controller('FaultMapCtrl', ['$scope', '$http', '$interval', '$sce', 'NgMap', function($scope, $http, $interval, $sce, NgMap){
	let gMap;
	$scope.timestamp;
	$scope.renewData = false;
	$scope.importantMessageShow = true;
	$scope.alertMessage = mapData.notifications.notification_red_text;
	$scope.warningMessage = mapData.notifications.notification_orange_text;
	$scope.newAlertMessage = mapData.notifications.notification_alert_text;
	$scope.alertMessageShow = !!mapData.notifications.notification_red_on;
	$scope.warningMessageShow = !!mapData.notifications.notification_orange_on;
	$scope.newAlertMessageShow = !!mapData.notifications.notification_alert_on;
	const dataUrl = mapData.dataUrl;
	const statusUrl = mapData.statusUrl;
	const statUrl = mapData.statUrl;
	const statusCheckInterval = mapData.statusCheckInterval * 1000;
	
	let statusInterval;
	let markerClusterer;
	let markers = [];
	let polygons = [];
	
	const zoomLevel = 11;
	let placeMarker;
	let placeInput;
	const markerZoom = 14;
	
	$scope.loader = false;
	$scope.placeStatus = false;

    $scope.info = {
        show: window.innerWidth > 768,
        data: undefined,
        loading: false,
        statistics: undefined,
        infoExpanded: false,
        statExpanded: window.innerWidth > 768
    };
	
	//changed image path
	MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = theme_path + 'img/faultmap/';
	
	$scope.filter = {
		fn: true,
		fp: true,
		fk: true
	};
	
	$scope.clearPlace = function(){
		if(typeof(placeMarker) !== 'undefined'){
			placeMarker.setMap(null);
			placeMarker = undefined;
		}
		if(!arguments[0] && typeof(placeInput) !== 'undefined'){
			placeInput.value = '';
		}
		$scope.placeStatus = false;
	};
	
	NgMap.getMap().then(function(map) {
		gMap = map;
		getData();
		getStatistics();
		
		// google place initialization
		function init() {
			placeInput = document.getElementById('locationTextField');
			const places = new google.maps.places.Autocomplete(placeInput, {
				componentRestrictions: {
					country: ["lt"]
				}
			});
			
			const address = document.getElementById("locationWrapper");
			google.maps.event.addListener(places, 'place_changed', function () {
				const place = places.getPlace();
				const lat = place.geometry.location.lat();
				const lng = place.geometry.location.lng();
				const latLng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
				$scope.clearPlace(true);
				placeMarker = new google.maps.Marker({
					position: latLng,
					clickable: false
				});
				placeMarker.setMap(gMap);
				gMap.setCenter(latLng);
				gMap.setZoom(markerZoom);
				$scope.placeStatus = true;
				$scope.$apply();
			});
			return address;
		}
const isMobile = window.innerWidth <= 768;
        const myOptions = {
            streetViewControl: false,
            zoomControl: !isMobile,
            fullscreenControl: false,
            addressControl: true,
            zoom: calculateZoom(),
            mapTypeControl: false,
            cameraControl: false,
            styles: [
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [{ visibility: "off" }]
                },
                {
                    featureType: "transit",
                    elementType: "labels.icon",
                    stylers: [{ visibility: "off" }],
                },
            ],
            restriction: {
                latLngBounds: {
                    north: 57.447902,
                    south: 51.953324,
                    east: 31.989427,
                    west: 16.780594,
                },
            },
        };
		map.setOptions(myOptions);
		
		const geoXml = new geoXML3.parser({
			map: map,
			suppressInfoWindows: true,
            zoom: false,
		});
		geoXml.parse(theme_path + 'kml/placemark.kml');
		init();

		map.addListener("bounds_changed", () => {
			if (angular.isDefined(markerClusterer)) {
				const bounds = map.getBounds();
				if (map.getZoom() <= zoomLevel) {
					for (const polygon of polygons) {
						polygon.setVisible(false);
						polygon.setMap(null);
					}
					for (const marker of markerClusterer.getMarkers()) {
						if (marker.dynamic && bounds.contains(marker.getPosition())) {
							marker.setVisible(true);
						}
					}
				} else {
					for (const marker of markerClusterer.getMarkers()) {
						if (marker.dynamic && bounds.contains(marker.getPosition())) {
							marker.setVisible(false);
						}
					}
					for (const polygon of polygons) {
						if (bounds.intersects(polygon.getBounds())) {
							polygon.setMap(gMap);
							polygon.setVisible(true);
						} else {
							polygon.setVisible(false);
							polygon.setMap(null);
						}
					}
				}
			}
		});
	});
	
	$scope.filterChange = function(){
		getData();
	};
	
	$scope.updateData = function(){
		$scope.closeInfo();
		getData();
		getStatistics();
	};
	
	function getData(){
		statusStop();
		$scope.loader = true;
		const rq = $http({
			method: 'GET',
			url: dataUrl,
			params: getDataParams()
		});
		rq.then(function(response){
			if(response.data.success){
				$scope.timestamp = response.data.timestamp;
				$scope.renewData = false;
				initMapData(response.data.data);
				statusStart();
			}
			else if(response.data.message){
				console.log(response.data.message);
			}
			$scope.loader = false;
		}, function(){
			$scope.loader = false;
		});
	}
	
	function getStatistics(){
		const rq = $http({
			method: 'GET',
			url: statUrl
		});
		rq.then(function(response){
			if(response.data.success){
				$scope.info.statistics = response.data.data;
			}
			else if(response.data.message){
				console.log(response.data.message);
			}
		}, function(){
			// on communication error
		});
	}
	
	function getDataParams(){
		const params = {};
		for(const i in $scope.filter){
			params[i] = ($scope.filter[i]) ? 1 : 0;
		}
		params.fg = ($scope.filter.fn) ? 1 : 0;
		return params;
	}

    function calculateZoom() {
        const width = window.innerWidth;
        const height = window.innerHeight;

        if (width <= 768) {
            return 6;
        }

        const minDimension = Math.min(width, height);

        if (minDimension < 600) {
            return 6;
        } else if (minDimension < 800) {
            return 7;
        } else if (minDimension < 1000) {
            return 7;
        } else {
            return 8;
        }
    }
	
	function initMapData(points){
		if (angular.isDefined(markerClusterer)) {
			markerClusterer.clearMarkers();
		}
		for (const polygon of polygons) {
			polygon.setMap(null);
		}
		markers = [];
		polygons = [];
		const currentZoom = gMap.getZoom();
		for (const d of points) {
			let element;
			const latLng = new google.maps.LatLng(parseFloat(d.lat), parseFloat(d.lng));
			if ((d.type == 'P' || d.type == 'N') && typeof(d.area) !== 'undefined' && d.area.length > 0) {
				const polyOptions = {
					paths: d.area,
					strokeColor: "#1976d2",
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: "#1976d2",
					fillOpacity: 0.35,
					pas_id: d.pas_id,
					fault_type: d.type,
				};
				if (d.type == 'N') {
					polyOptions.strokeColor = '#ef404a';
					polyOptions.fillColor = '#ef404a';
				}
				polyOptions.bounds = new google.maps.LatLngBounds();
				for (const g of d.area) {
					for (const ll of g) {
						polyOptions.bounds.extend(new google.maps.LatLng(parseFloat(ll.lat), parseFloat(ll.lng)));
					}
				}
				const poly = new google.maps.Polygon(polyOptions);
				poly.getPosition = function() {
					return new google.maps.LatLng(parseFloat(d.lat), parseFloat(d.lng));
				};
				poly.getBounds = function(){
					return this.bounds;
				};
				google.maps.event.addListener(poly, 'click', function(){
					showPointInfo(d);
				});
				polygons.push(poly);
				
				element = new google.maps.Marker({
					position: latLng,
					clickable: true,
					pas_id: d.pas_id,
					fault_type: d.type,
					dynamic: true,
					icon: {
						url: MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ + d.type +'sq.svg',
						scaledSize: new google.maps.Size(56, 56),
					}
				});
			} else {
				element = new google.maps.Marker({
					position: latLng,
					clickable: true,
					pas_id: d.pas_id,
					fault_type: d.type,
					dynamic: false,
					icon: {
						url: MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ + d.type +'sq.svg',
						scaledSize: new google.maps.Size(56, 56),
					}
				});
			}
			google.maps.event.addListener(element, 'click', function(){
				showPointInfo(d);
			});
			markers.push(element);
		}
		
		const calc = function(markers) {
			const unique = [...new Set(markers.map(item => item.fault_type))];
			const outp = {text: '', index: 1};
			if (unique.length == 1) {
				switch (unique.shift()) {
					case 'K':
						outp.index = 4;
						break;
					case 'N':
						outp.index = 3;
						break;
					case 'G':
						outp.index = 3;
						break;
					case 'P':
						outp.index = 2;
						break;
				}
			}
			return outp;
		};
		
		const mcOptions = {
			maxZoom: zoomLevel, // jei daugiau, clusteringas issijungia
			styles: [
				{
					height: 56,
					url: theme_path + 'img/faultmap/zoom.png',
					width: 56,
				},
				{
					height: 56,
					url: theme_path + 'img/faultmap/planned_dc.png',
					width: 56,
				},
				{
					height: 56,
					url: theme_path + 'img/faultmap/fault.png',
					width: 56,
				},
				{
					height: 56,
					url: theme_path + 'img/faultmap/client_fault.png',
					width: 56,
				}
			]
		};

		markerClusterer = new MarkerClusterer(gMap, markers, mcOptions);
		markerClusterer.setCalculator(calc);
		if (gMap.getZoom() != zoomLevel) {
			google.maps.event.trigger(gMap, 'bounds_changed');
		}
	}

	function statusStart(){
		if (angular.isDefined(statusInterval)) return;
		statusInterval = $interval(function(){
			$http({
				method: 'GET',
				url: statusUrl
			}).then(function(response){
				if(response.data.success && response.data.timestamp > $scope.timestamp){
					$scope.renewData = true;
					statusStop();
				}
			}, function(){
				statusStop();
			});
		}, statusCheckInterval);
	}
	
	function statusStop(){
		if(angular.isDefined(statusInterval)){
			$interval.cancel(statusInterval);
            statusInterval = undefined;
		}
	}
	
	function showPointInfo(point){
		$scope.info.show = true;
		$scope.info.loading = true;
		$scope.info.infoExpanded = true;
		$scope.info.statExpanded = false;
		$scope.$apply();
		const params = getDataParams();
		params.pas_id = point.pas_id;
		$http({
			method: 'GET',
			url: mapData.pointUrl,
			params: params
		}).then(function(response){
			$scope.info.loading = false;
			if(response.data.success){
				$scope.info.data = response.data.data;
			}
		}, function(){
			// noop
		});
	}
	
	$scope.closeInfo = function(){
		$scope.info.show = false;
		$scope.info.loading = true;
		$scope.info.data = undefined;
		$scope.info.infoExpanded = false;
		$scope.info.statExpanded = false;
		$scope.info.usefulLinksExpanded = false;
	};

    $scope.infoToogle = function(fld){
        if (fld === 'infoExpanded') {
            $scope.info.infoExpanded = !$scope.info.infoExpanded;
            if ($scope.info.infoExpanded) {
                $scope.info.statExpanded = false;
                $scope.info.usefulLinksExpanded = false;
            }
        } else if (fld === 'statExpanded') {
            $scope.info.statExpanded = !$scope.info.statExpanded;
            if ($scope.info.statExpanded) {
                $scope.info.infoExpanded = false;
                $scope.info.usefulLinksExpanded = false;
            }
        } else if (fld === 'usefulLinksExpanded') {
            $scope.info.usefulLinksExpanded = !$scope.info.usefulLinksExpanded;
            if ($scope.info.usefulLinksExpanded) {
                $scope.info.infoExpanded = false;
                $scope.info.statExpanded = false;
            }
        }
    };

    $scope.toogleStat = function(){
        $scope.info.loading = false;
        if($scope.info.show && !$scope.info.statExpanded){
            $scope.info.infoExpanded = false;
            $scope.info.statExpanded = true;
            $scope.info.usefulLinksExpanded = false;
        }
        else{
            $scope.info.show = !$scope.info.show;
            $scope.info.infoExpanded = false;
            $scope.info.statExpanded = true;
            $scope.info.usefulLinksExpanded = false;
        }
    };

	$scope.hideAlertMessage = function() {
		$scope.alertMessageShow = false;
	};

	$scope.hideWarningMessage = function() {
		$scope.warningMessageShow = false;
	};
	$scope.hideAlertNewMessage = function() {
		$scope.newAlertMessageShow = false;
	};
	
	$scope.explicitlyTrustedHtml = function(text) {
        return $sce.trustAsHtml(text);
	};
	
}]);
